import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/all'
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const headerHeight = document.querySelector('header.header')?.clientHeight || 0

  const SELECTORS = {
    hero: ".on-demand-hero",
    heading: ".on-demand-heading .banner-content",
    wrapper: ".on-demand-hero-wrapper",
    footer: ".on-demand-hero-footer",
  };

  const mm = gsap.matchMedia();

  mm.add(
    {
      isDesktop: "(min-width: 1024px)",
      isMobile: "(max-width: 1023px)",
    },
    (context) => {
      const { isDesktop } = context.conditions as {
        isDesktop: boolean;
        isMobile: boolean;
      };

      const endpoint = isDesktop
        ? window.innerHeight * 1.5
        : window.innerHeight;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: SELECTORS.hero,
          start: () => `top top`,
          end: `+=${endpoint}`,
          pin: true,
          scrub: 1,
        },
      });

      // Shared animation
      tl.to(SELECTORS.heading, {
        yPercent: -55,
        opacity: 0,
        duration: isDesktop ? 0.5 : 2.5,
      });

      if (isDesktop) {
        desktopAnimation(tl);
      } else {
        mobileAnimation(tl);
      }
    }
  );

  function desktopAnimation(tl: gsap.core.Timeline) {
    tl.fromTo(
      SELECTORS.wrapper,
      { scale: 1.25 },
      {
        scale: 0.9,
        duration: 1.5,
        ease: "none",
      },
      "<"
    );

    tl.fromTo(
      SELECTORS.footer,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 1.5,
        ease: "none",
      },
      "<"
    );

    tl.to(SELECTORS.wrapper, {
      scale: 0.64,
      duration: 0.75,
      ease: "none",
    });
  }

  function mobileAnimation(tl: gsap.core.Timeline) {
    const heroEl = document.querySelector(SELECTORS.hero) as HTMLElement
    const wrapperEl = document.querySelector(SELECTORS.wrapper) as HTMLElement
    if (!heroEl || !wrapperEl) return

    const heroHeight = heroEl.offsetHeight
    const wrapperHeight = wrapperEl.offsetHeight
    const negativeMargin = -((heroHeight - wrapperHeight) / 2) + 50

    tl.fromTo(
      SELECTORS.wrapper,
      { scale: 5.81 },
      {
        scale: 1,
        duration: 2.5,
        ease: "none",
      },
      "<"
    );

    tl.to(SELECTORS.wrapper, {
      scale: 1,
      duration: 2.25,
      ease: "none",
    });

    tl.to(SELECTORS.footer, {
      marginTop: negativeMargin,
      ease: "none",
    },  "-=4");
  }
});